<template>
  <div class="container my-5">
    <b-card class="text-center p-4 shadow border-0">
      <h2 class="mb-4">
        {{ $t("delete_your_account") }}
      </h2>
      <p>{{ $t('please_let_us_know_the_reason_you_leave') }}</p>

      <b-form @submit.prevent="showModal">
        <b-form-group>
          <b-form-radio-group
            v-model="selectedReason"
            :options="reasonOptions"
            name="reasonRadios"
            class="mb-3"
            stacked
          />
        </b-form-group>

        <b-button
          variant="danger"
          :disabled="!!!selectedReason && sendOtpLoading"
          @click="showModal"
        >

          <span v-if="!sendOtpLoading">
            {{ $t('delete_your_account') }}
          </span>
          <b-spinner
            v-else
            small
            size="10"
            variant="light"
            type="grow"
          />
        </b-button>
      </b-form>
    </b-card>

    <b-modal
      v-model="otpModal"
      :title="$t('confirm_delete_account')"
      centered
      size="md"
      hide-footer
      no-close-on-backdrop
    >
      <validation-observer
        #default="{invalid}"
      >
        <b-row>
          <b-col>
            <div
              v-if="mobile"
              class="my-1"
            >
              {{ $t('delete_account_confirm_description', { mobile }) }}
            </div>
            <b-form
              class="auth-login-form mb-2"
            >
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="code">{{ $t('confirm_delete_code') }}</label>
                </div>
                <validation-provider
                  #default="{ errors }"
                  :name="$t('confirm_delete_code')"
                  vid="code"
                  rules="required"
                >
                  <b-input-group>
                    <b-form-input
                      id="code"
                      v-model="confirmCode"
                      name="code"
                      placeholder="0000"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <b-button
              block
              size="md"
              variant="warning"
              :disabled="verifyCounter !== 0"
              @click="sendOtp(true)"
            >
              <div v-if="!resendOtpLoading">
                <span>
                  {{ $t('resend') }}
                </span>
                <span v-if="verifyCounter !== 0">({{ verifyCounter }})</span>
              </div>
              <b-spinner
                v-else
                small
                size="10"
                variant="light"
                type="grow"
              />
            </b-button>
          </b-col>
          <b-col cols="6">
            <b-button
              block
              size="md"
              :disabled="invalid || confirmCode.length < 4"
              variant="success"
              @click="deleteAccount"
            >
              <span v-if="!verifyLoading">
                {{ $t('widrawModal.confirm') }}
              </span>
              <b-spinner
                v-else
                small
                size="10"
                variant="light"
                type="grow"
              />
            </b-button>
          </b-col>
        </b-row>
      </validation-observer>
    </b-modal>
  </div>
</template>

<script>
import deleteAccount from '@/views/logics/profile/deleteAccount'

export default {
  mixins: [deleteAccount],
}
</script>

  <style scoped>
  .container {
    max-width: 600px;
    margin: 0 auto;
  }
  .b-card {
    background-color: transparent !important;
    box-shadow: none !important;
  }
  .b-modal {
    max-width: 500px;
  }
  .modal-header {
    border-bottom: none;
  }
  .modal-footer {
    border-top: none;
  }
  </style>
